import {put, delay, takeEvery, select, call, all} from "redux-saga/effects";
import SettingsAction from "../settings/settingsAction";
import AdidAction from "./adidAction";
import fakeRequests from "../../mock/adid/requests.json";
import fakeLocations from "../../mock/adid/target.json";

import {transformAdidRequests, transformAdidTarget} from "./adidTransformer";
import {apiAdidService, apiCaseService} from "../../config/api";
import InvestigationAction from "../investigation/investigationAction";

function* createAdidRequestSaga(action) {
  const {caseId, msisdn, callback} = action.payload;
  try {
    //const {data} = yield apiCaseService.getAllFavoriteTargets(targetType?.toUpperCase());
    const {data} = yield apiCaseService.createADIDProfile(caseId, {phone: msisdn, country: 'us'});

    //yield delay(2000);

    callback({data, status: 'success'});

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    callback({status: 'error'});
  }
}

function* createAdidTargetSaga(action) {
  const {caseId, createData, callback} = action.payload;
  try {
    //const {data} = yield apiCaseService.getAllFavoriteTargets(targetType?.toUpperCase());
    const {data} = yield apiCaseService.createADIDProfile(caseId, createData);

    yield put(InvestigationAction.getTargetsList(caseId, 'ADID', {page: 0, size: 200}));

    callback({data, status: 'success'});

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    callback({status: 'error'});
  }
}

function* createPolygonTargetSaga(action) {
  const {caseId, createData, callback} = action.payload;
  try {
    const geoValues = {
      geoRequest: {
        latitude: createData?.latitude,
        longitude: createData?.longitude,
        radius: createData?.radius * 1000,
      },
      type: 'GEO',
    }
    const {data} = yield apiCaseService.createADIDGEOProfile(caseId, geoValues);
    //yield delay(2000);

    yield put(InvestigationAction.getTargetsList(caseId, 'ADID', {page: 0, size: 200}));

    callback({data, status: 'success'});

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    callback({status: 'error'});
  }
}



function* getAdidRequestsSaga(action) {
  const {caseId, filters, callback} = action.payload;
  try {
    const {data: apiData} = yield apiCaseService.getPhoneRequest(caseId, 0, 200);
    console.log('apiData', apiData);

    //const data = yield fakeRequests;
    //yield delay(2000);

    callback({status: 'success', content: transformAdidRequests(apiData)});

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
    callback({status: 'error'});
  }
}

function* getAdidTargetSaga(action) {
  const {id, callback} = action.payload;
  try {
    //const data = yield fakeLocations;
    const {data: adidTarget} = yield apiAdidService.getADIDProfile(id);
    console.log('adidTarget', adidTarget);

    const {locations = [], adidInfo = {}, targetData = {}} = transformAdidTarget(adidTarget);

    yield put(AdidAction.updateAdidState({locations, adidInfo, targetData}));

    callback(locations);

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

export function* watchAdid() {
  yield takeEvery(AdidAction.CREATE_ADID_REQUEST, createAdidRequestSaga);
  yield takeEvery(AdidAction.CREATE_ADID_TARGET, createAdidTargetSaga);
  yield takeEvery(AdidAction.CREATE_POLYGON_TARGET, createPolygonTargetSaga);
  yield takeEvery(AdidAction.GET_ADID_REQUESTS, getAdidRequestsSaga);
  yield takeEvery(AdidAction.GET_ADID_TARGET, getAdidTargetSaga);
}
